var $ = require('jquery');

// Footer Position
function footerPosition() {
    var browser = $(window),
        footerHeight = $('.footer').outerHeight(true),
        contentArea = $('.content-wrapper');

    // reset content area height before making calculations
    contentArea.css('min-height', 'initial');

    // once images are loaded check if the area remaining is larger than the container and if so increase the height of the container
    contentArea.imagesLoaded(function() {
        if((footerHeight + contentArea.outerHeight()) < browser.height()) {
            contentArea.css('min-height', (browser.height()-footerHeight));
        } else {
            contentArea.css('min-height', 'initial');
        }
    });
}

module.exports = footerPosition;



// WEBPACK FOOTER //
// ./themes/base/js/footer-position.js